// 選択Modal共通の「やめる/クリア ＋ けってい」フッター。
// ボタンは あそぶ画面のスタートボタンと同じ形（やめる/クリア=青、けってい=緑固定）。
import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";
import { PillSize, PillColor, BuilderPillButton } from "./BuilderPillButton";

export const MenuActionFooter = ({
  onApply,
  secondaryLabel,
  onSecondary,
}: {
  // 互換のため受け取るが未使用（けっていは常に有効・緑固定）
  canApply?: boolean;
  onApply: () => void;
  // 左ボタンの文言キー（やめる / クリア）
  secondaryLabel: string;
  onSecondary: () => void;
  // 互換のため受け取るが未使用（けっていは緑固定）
  accentBgClass?: string;
}) => {
  const play = usePlaySound();

  const handleApply = () => {
    play();
    btnDelay(onApply);
  };

  const handleSecondary = () => {
    play();
    btnDelay(onSecondary);
  };

  return (
    <div className="flex-row-el flex-center justify-end w-full gap-4 pb-2">
      <BuilderPillButton
        color={PillColor.BLUE}
        size={PillSize.MD}
        icon="close"
        label={I18n.t(secondaryLabel)}
        onClick={handleSecondary}
      />
      <BuilderPillButton
        color={PillColor.GREEN}
        size={PillSize.MD}
        icon="check"
        label={I18n.t("MSG_CONFIRM_BTN")}
        onClick={handleApply}
      />
    </div>
  );
};
